import { Pipe, PipeTransform } from "@angular/core";
import { Prescription } from "../backend/models/prescription/prescription";

@Pipe({
  name: "nameDrugs",
  standalone: false
})
export class NameDrugsPipe implements PipeTransform {
  transform(value: Prescription | undefined): string {
    if (!value) {
      return "";
    }

    return value.drugs?.map((d) => d.name).join(", ") || "";
  }
}
